import React from 'react';
import styled from 'styled-components';

import { colors, MOBILE_BREAKPOINT } from '../../constants';
import { ClickableSup, onSuperscriptClick } from '../Footer';
import Heading from '../Heading';
import Highlighter from '../Highlighter';
import SubHeading from '../SubHeading';

/* Styles for the heading on Apply start pages */
export const ApplyFormHeadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
`;
ApplyFormHeadingContainer.displayName = 'ApplyFormHeadingContainer';

export const FormHeading = styled(Heading)`
  max-width: 25.5rem;
  margin: 0 0 0.4375rem;
  line-height: 2rem;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin: 0.4375rem 0 0.5625rem 0;
  }
`;
FormHeading.displayName = 'FormHeading';

const BackButton = styled.button`
  position: absolute;
  top: 2.8125rem;
  left: 2.1875rem;
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    display: none;
  }
`;
BackButton.displayName = 'BackButton';

export const FormSubHeading = styled(SubHeading)`
  margin: 0;
  line-height: 1.6875rem;
  max-width: 100%;
  color: ${colors.TEXT_PRIMARY};
  @media (max-width: ${MOBILE_BREAKPOINT}) {
    max-width: 90%;
  }
`;
FormSubHeading.displayName = 'FormSubHeading';

/* Main component- a header, and a subheader with highlight/superscript
  uses specific text- components above can be used alone if needed */
export const ApplyHeading = () => (
  <ApplyFormHeadingContainer>
    <FormHeading>Take charge of your credit</FormHeading>
    <FormSubHeading>
      <Highlighter>&nbsp;Checking your offer won’t affect</Highlighter>
      <Highlighter>
        &nbsp;your credit score
        <ClickableSup
          id="footnote-source-1"
          tabIndex={0}
          onClick={() => onSuperscriptClick('footnote-1')}
          aria-label="footnote-1"
          role="link"
          isOnApply
        >
          ¹
        </ClickableSup>
      </Highlighter>
    </FormSubHeading>
  </ApplyFormHeadingContainer>
);
